import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { selectUserToken } from '../redux/features/user/userSelectors';
import {
  useUpdateRealtyMutation,
  useAddRealtyMutation,
  useDeleteRealtyMutation,
  useAddRealtyLikeMutation,
} from '../redux/services/realties/realtiesApi';

//!TODO: Add similar hooks for other apis
//! OR update api.js to auto inject token into each request
/**
 * Wrapper hook for realty mutations to avoiud repeating token injection.
 *
 * @returns {Object} Simplified mutation functions
 *
 */
export const useRealtyMutations = () => {
  const token = useSelector(selectUserToken);

  const [updateRealtyMutation, updateRealtyState] = useUpdateRealtyMutation();
  const [addRealtyMutation, addRealtyState] = useAddRealtyMutation();
  const [deleteRealtyMutation, deleteRealtyState] = useDeleteRealtyMutation();
  const [addRealtyLikeMutation, addRealtyLikeState] =
    useAddRealtyLikeMutation();

  const updateRealty = useCallback(
    ({ id, data }) => {
      return updateRealtyMutation({ token, id, data });
    },
    [token, updateRealtyMutation]
  );

  const addRealty = useCallback(
    ({ data }) => {
      return addRealtyMutation({ token, data });
    },
    [token, addRealtyMutation]
  );

  const deleteRealty = useCallback(
    ({ id }) => {
      return deleteRealtyMutation({ token, id });
    },
    [token, deleteRealtyMutation]
  );

  const addRealtyLike = useCallback(
    ({ data }) => {
      return addRealtyLikeMutation({ token, data });
    },
    [token, addRealtyLikeMutation]
  );

  return {
    updateRealty,
    addRealty,
    deleteRealty,
    addRealtyLike,

    //  RTK response states
    updateRealtyState,
    addRealtyState,
    deleteRealtyState,
    addRealtyLikeState,
  };
};
